import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';
import Guseritem from './Guetitem';
import axios from 'axios';
import {showhidediv,clrwidgate,insertpost,gets} from './userdefaultdata';
import {actptnr} from './Uactingwithprtnr';
export default class Useractivities extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "profilepic";
	
  	}
	
    state = {

	
        name: "",
       respdata: null,   
       url: "",
     
      uset:{pfpid:0,age:0,utf:true,uname:'',points:0},
      isf:true,
      uage:0,
      pnt:0,
      ismsgshow:true,
      ishidesetiing:false,
      vtid:1,
      
      items:[{actid:0,acttp:0,actname:"act name"}],
    };
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
   
   getuseract(){
  
 try {
         
	

         const userid = Usersession.getUserId();
      const  service ="/getuseracts?prd="+userid;
    
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
              
		const tdata = response.data;
		this.reducearr(tdata);
		
            })
            .catch((err: any) => {
            
            });

                
          }
        catch (e) {
            //debugger;
	
        }
    
   }
 reducearr(arr:any){
       //let data = JSON.stringify(arr);
       // alert(data);
	let farr = [
		{
		actid:0,acttp:0,actname:"act name"
		},
		   ]

	 if(arr){
            
	     if(arr.length > 0){
              
		for(let i =0;i< arr.length;i++){
                
                 const rv = arr[i];
                
		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 1){
	 farr.shift();
	}
       //userchats = farr;
       this.setState({ items: farr });

     }

  
    componentDidMount() {
        debugger;
        
	this.getuseract();
    }
   activitywithusr(e:any,id:any){
	 const userid = Usersession.getUserId();
	const apiurl = '/adduseractivity';
    
       const rvuid = Usersession.getRecvactid();

 	const unm = Usersession.getUsername();
  
      const pin = Usersession.getUserpin();
     const sid = gets('Superuserid');
     

      //alert(rvuid+' : '+ userid );
        const obj = {adminid:sid,upin:pin,uname:unm,points:1,
		actid:id,sndrid:userid,rsvrid:rvuid,actpt:0,sts:0
		};
        insertpost(apiurl,obj); 
		
       

   }
   closeacting(e:any){
    
	clrwidgate('actevt');
       showhidediv(true,'useractwithptnr');

   }  

 render() {

   
     return (
     <div className="c-pfp-line">

       <div>
	<div style={{height:'auto',width:'100%'}}>  
 	   
           <div style={{height:'auto'}}>
            
           {this.state.items.map((row,index)=>(
            <div style={{height:'auto'}} className="purchase-itm-nm">
		
             
	    <div id="dvitem" style={{height:'auto',width:'100%'}} className="p-usr-act-nm">
 		<a href="#" className="blanka" onClick={e=>this.activitywithusr(e,row.actid)} title="Activity name">

	          <div className="per100" title={row.actname}>  
  		      
			{row.actname}(1 point)
	        	
		  </div>
		               
		</a>
             	</div>
	
	    </div>
       ))}	


       
        </div> 


       </div> 

    </div>

	
  
 </div>
   
   
      );
}
}

